module.exports = "<div>This is a page for demo survey</div>\n<survey survey-key=\"'DEMO'\" survey-round-key=\"'DEMO_ROUND'\" />\n";